"use client";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { BsChevronDoubleRight, BsExclamationTriangle } from "react-icons/bs";
import Link from "next/link";
import { Collapse, InputAdornment } from "@mui/material";
import { FaSearch } from "react-icons/fa";
import { useQuery } from "react-query";
import { Products } from "@/lib/http";
import { useRouter } from "next/navigation";
import TextInput from "@/components/common/form/TextInput";
import NoRecordFound from "@/components/common/NoRecordFound";
import { IProduct } from "@/lib/interface";
import ProductCardLoading from "@/components/products/ProductCardLoading";
import ProductCard from "@/components/products/ProductCard";
import { debounce } from "@mui/material/utils";
import { useSelector } from "react-redux";

export interface ISearchProps {
  close: () => void;
}

const SearchBox: React.FC<ISearchProps> = (props) => {
  const { countrySlug } = useSelector((state: any) => state.app);
  const { close } = props;
  const [searchText, setSearchText] = useState("");
  const [productData, setProductData] = useState([]);
  const searchRef = useRef<any>(null);
  const router = useRouter();
console.log('countrySlug--SearchBox',countrySlug)
  const handleClick = (e: Event) => {
    if (searchRef && searchRef.current)
      if (!searchRef.current?.contains(e.target)) {
        close();
      }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick, true);
    return window.removeEventListener("click", handleClick);
  }, []);

  const { isLoading } = useQuery({
    queryKey: ["search-products", searchText, countrySlug],
    queryFn: async () => {
      if (searchText) {
        const res = await Products.api("get", {
          params: "search",
          postfix: `?Search=${searchText}&CountrySlug=${countrySlug}`,
        });
        if (res?.status === 200) {
          setProductData((prev: any) => {
            if (res.data?.length) return [...res.data];
            else return prev;
          });
        }
      }
    },
  });

  const handleInputChange = (e: any) => {
    // console.log("Event ",e.target.value)
    setSearchText(e.target.value);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceHandler = useCallback(debounce(handleInputChange, 300), []);

  return (
    <div className=" bg-transparent absolute left-0 top-[100%] w-full  px-5 md:px-0">
      <div
        ref={searchRef}
        className="shadow  xl:w-[60%] md:w-[90%] w-[95%] flex flex-col  rounded-md bg-white  absolute right-0  md:right-[6%] top-[90%] z-[99] p-3   md:mx-0"
      >
        <div className="md:w-[50%] border-b md:mx-auto">
          <TextInput
            name="searchText"
            placeholder="Search Products ...."
            onChange={debounceHandler}
            variant="search"
            endAdornment={
              <InputAdornment
                position="start"
                className="p-2 h-auto w-auto cursor-pointer hover:text-primary-main"
              >
                <FaSearch
                  onClick={() => {
                    close();
                    router.push(`/search?searchText=${searchText}`);
                  }}
                />
              </InputAdornment>
            }
          />
        </div>

        <Collapse in={searchText ? true : false}>
          {searchText ? (
            <div className="flex justify-between  py-2 ">
              <h4 className="font-semibold text-md text-secondary-dark flex items-center">
                {searchText}
              </h4>
              {productData?.length ? (
                <Link
                  href={`/search?searchText=${searchText}`}
                  onClick={close}
                  className="text-md font-semibold gradient-text !flex items-center"
                >
                  View All <BsChevronDoubleRight />{" "}
                </Link>
              ) : null}
            </div>
          ) : null}
          <div className="h-[50vh] overflow-y-scroll">
            {" "}
            <div className="grid  lg:grid-cols-4 grid-cols-2 md:grid-cols-3  gap-6 overflow-y-scroll no-scrollbar  flex-1 ">
              {isLoading ? (
                <>
                  <ProductCardLoading variant="small" />
                  <ProductCardLoading variant="small" />
                  <ProductCardLoading variant="small" />
                  <ProductCardLoading variant="small" />
                </>
              ) : productData.length ? (
                productData.map((p: IProduct) => {
                  return (
                    <ProductCard
                      variant="small"
                      {...p}
                      onClick={close}
                      key={p.ProductID}
                      country={countrySlug || ""}
                    />
                  );
                })
              ) : (
                <div className=" w-full items-center justify-center col-span-2 md:col-span-3 lg:col-span-4 my-10 ">
                  <div className="flex flex-col justify-center items-center">
                    {" "}
                    <BsExclamationTriangle className="text-5xl text-gray-300 mb-5" />
                    <h1 className="text-3xl mb-5 font-bold text-secondary-dark text-center ">
                      0 Results found for{" "}
                      <span className="text-primary-main">{`"${searchText}"`}</span>
                    </h1>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default SearchBox;
